/**
 * Authors: mariushirjanu
 * Created: 27/04/2021
 */
import * as _ from 'underscore';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IObject } from '../../../type_definitions/datatypes';
import { GaStateService } from '../services/ga-state.service';

@Injectable()
export class TranslationService {

  constructor(
    private translateService:TranslateService,
    private gaStateService:GaStateService
  ) {
    /**/
  }

  /**
   Comparing with this.translateService.instant, these methods allows to only pass a short key (eg. NUM_ACTIVE_COUNTRIES instead WEBSHOP.SUPPLIER.NUM_ACTIVE_COUNTRIES.TEXT) as well a short key for the interpolated parameter label which will be translated
   */
  public instant(key:string | string[], interpolateParams?:IObject):string {
    return this.getTranslatedkey(key, this.getTranslatedInterpolateParams(interpolateParams));
  }

  private getTranslationKey:Function = (key:string):string => `${this.gaStateService.screen}.${key}.${key === 'HEADING'? 'title' : 'text'}`.toUpperCase(); // compose the translation key;

  private getTranslatedkey(key:string | string[], interpolateParams?:IObject):string {
    let translatedKey = key;
    try {
      const translatedSimpleKey:string = this.translateService.instant(key, interpolateParams);

      // when initial key is different than translatedSimpleKey -> a translation has been performed and we return that translation
      if (key !== translatedSimpleKey) {
        translatedKey = translatedSimpleKey;
      } else {
        // try a second attempt by translating the full translation key (includes the screen and type)
        const fullTranslationKey:string = this.getTranslationKey(key);
        const translatedFullKey = this.translateService.instant(fullTranslationKey, interpolateParams);
        // use it only if a real translation has been performed (text is different than the composed key)
        if (fullTranslationKey !== translatedFullKey) {
          translatedKey = translatedFullKey;
        }
      }
    } catch (e) {/***/
    }

    return <string>translatedKey;
  }

  private getTranslatedInterpolateParams(interpolateParams?:IObject) {
    // translate interpolate parameter 'label'
    _.each(interpolateParams, (v:any, k:string) => {
      let translatedInterpolatedParam;
      if (k === 'label') {
        try {
          translatedInterpolatedParam = this.translateService.instant(v); // try to translate the label as it is provided
          if (v === translatedInterpolatedParam) {
            translatedInterpolatedParam = this.translateService.instant(this.getTranslationKey(v)); // try to translate the label based on the current screen
          }
          if (this.getTranslationKey(v) === translatedInterpolatedParam) {
            translatedInterpolatedParam = v; // fallback to the original value
          }
          interpolateParams[ k ] = translatedInterpolatedParam;
        } catch (e) {/***/
        }
      }
    });

    return interpolateParams;
  }

  /**
   For checking if a given key has translation
   */
  public isTranslatable(key:string):boolean {
    return !_.isEmpty(this.instant(key).trim());
  }
}